export default __webpack_public_path__ + "static/media/code-02.dde52e35.svg";